import { SiteFilesViewerComponent } from './SiteFilesViewer.component';
import { enhance } from './SiteFilesViewer.enhancers';

export const SiteFilesViewer = enhance(SiteFilesViewerComponent);
